//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Menus'
}



// WEBPACK FOOTER //
// ./src/views/Home/components/Menus/Menus.vue